<h5>{{applicant.Title}} {{applicant.FirstName}} {{applicant.MiddleName}} {{applicant.Surname}}</h5>
<dl class="c-detail__list">
  <dt class="c-detail__list-title">Date of birth</dt>
  <dd class="c-detail__list-description">{{DateOfBirth}}</dd>
  <dt class="c-detail__list-title">Phone number</dt>
  <dd class="c-detail__list-description">{{applicant.PhoneNumber}}</dd>
  <dt class="c-detail__list-title">Email</dt>
  <dd class="c-detail__list-description">{{applicant.EmailAddress}}</dd>
</dl>
@for (add of applicant.Addresses; track add; let i = $index) {
  <ng-container class="mb-2">
    <recap-applicant-address [applicantIterator]="applicantIterator" [address]="add" [iterator]="i" [doAddressMatch]="doAddressMatch" [addressMatchDoneAlready]="addressMatchDoneAlready" (addressMatchOut)="takeAddressMatchObject($event)"></recap-applicant-address>
  </ng-container>
}
<dl class="c-detail__list">
  <dt class="c-detail__list-title c-detail-xs">Can we stay in touch?</dt>
  <dd class="c-detail__list-description c-detail-xs">{{applicant.OkToContact ? 'Yes' : 'No' }}</dd>
</dl>
@if (applicant.OkToContact === true) {
  <dl class="c-detail__list">
    <dt class="c-detail__list-title c-detail-xs">Email</dt>
    <dd class="c-detail__list-description c-detail-xs">{{applicant.ContactByEmail ? 'Yes' : 'No' }}</dd>
    <dt class="c-detail__list-title c-detail-xs">Phone</dt>
    <dd class="c-detail__list-description c-detail-xs">{{applicant.ContactByPhone ? 'Yes' : 'No' }}</dd>
    <dt class="c-detail__list-title c-detail-xs">SMS</dt>
    <dd class="c-detail__list-description c-detail-xs">{{applicant.ContactByTextOrSms ? 'Yes' : 'No' }}</dd>
    <dt class="c-detail__list-title c-detail-xs">Post</dt>
    <dd class="c-detail__list-description c-detail-xs">{{applicant.ContactByPost ? 'Yes' : 'No' }}</dd>
  </dl>
}
